import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchSitesData } from '../../utils/apiCommonMethods';

export const fetchSites = createAsyncThunk(
  'sites/fetchSites',
  async (msSessionInfo, { rejectWithValue }) => {
    try {
      const data = await fetchSitesData(msSessionInfo);
      return data;
    } catch (error) {

      return rejectWithValue(error?.response?.data || error.message);
    }
  }
);

const sitesSlice = createSlice({
  name: 'sites',
  initialState: { data: [], fetched: false, loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSites.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSites.fulfilled, (state, action) => {
        state.loading = false;
        state.fetched = true;
        state.data = action.payload ?? [];
      })
      .addCase(fetchSites.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error?.message || 'Failed to fetch sites';
      });
  },
});

export default sitesSlice.reducer;
